import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionTypes extends Layout {
    sourceRenditionTypes: DataSource;
    tbTypepDesc: Textbox;
    tbTypepId: Textbox;
}
